import script from "./ModalComp.vue?vue&type=script&setup=true&lang=ts"
export * from "./ModalComp.vue?vue&type=script&setup=true&lang=ts"

import "./ModalComp.vue?vue&type=style&index=0&id=fa761d04&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fa761d04"]])

export default __exports__